import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { logQrScanEvent } from "../../services/analytics";
import { QRScanEvent } from "../../dto/analyticsDto";

const Redirect = () => {
    const [searchParams] = useSearchParams();
    const url = searchParams.get("url");
    const doctorId = searchParams.get("doctorId");
    const decodedUrl = url ? decodeURIComponent(url) : "/";

    useEffect(() => {
        if (decodedUrl) {
            window.location.href = decodedUrl;

            if (doctorId) {
                logQrScanEvent({
                    doctorId: doctorId,
                    event: QRScanEvent.SCAN_TO_WHATSAPP
                });
            }
        } else {
            console.error("Redirect Error: The 'decodedUrl' URL parameter is missing.");
        }
    }, []);
    return <></>;
};

export default Redirect;
